import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import BlogMain from './BlogMain';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';

const Blog = () => {
  return (
    <>
      <HeaderFive />

      <BlogMain />

      <FooterThree />
    </>
  );
};

export default Blog;
